// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a13a6c84","451":"5bbadb6b","453":"31bf9d75","667":"93088408"}[chunkId] + ".chunk.js";
};